<div class="business-navbar__modal__footer" [ngClass]="{'business-navbar__modal__footer--mobile': (isMobile$ | async)}">
    <ng-content></ng-content>
</div>
